export const ALERT_LAYER_ID_GLOBAL = 'alerts-layer';
export const PERSON_DETAIL_LAYER_ID_GLOBAL = 'person-detail-layer';

export const MAX_PERSONS_IN_LIST_DRAWER = 500;
export const MAX_SITES_IN_LIST_DRAWER = 500;
export const MAX_OCCUPANTS_IN_LIST_DRAWER = 500;
export const MAX_PHYSICAL_SECURITY_IN_LIST_DRAWER = 500;
export const MAX_ALERTS_IN_LIST_DRAWER = 500;

export const MAP_LOCATIONS_FILTER = 'locationsFilter';

// navFrom values passed via router location state to tell WorldMapPage which navigation to handle
export const MAP_NAV_KEYS = {
  ALERT_DETAILS: 'alertDetails',
  LOCATION_DETAILS: 'locationDetails',
  PERSON_DETAILS: 'personDetails',
  SITE_PROFILE: 'siteProfile',
};

export const ALERT_SOURCE_ID = 'alerts-source';
export const ALERT_LAYER_ID = ALERT_LAYER_ID_GLOBAL;
export const ALERT_CLUSTER_LAYER_ID = 'alerts-clustered-layer';
